module.exports = __webpack_public_path__ + "assets/img/b18a9cf98863124cc9b68a2e64256d57.svg";